import React, { useState } from "react";
import Logo from "../assets/logo.svg";
import { RiMenu3Fill, RiCloseFill } from "react-icons/ri";
import { motion } from "framer-motion";

const Navbar = ({ activeSection }) => {
  const [isOpen, setIsOpen] = useState(false);

  const navAnimation = {
    hidden: { opacity: 0, y: -50 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        staggerChildren: 0.1
      }
    }
  };

  const itemAnimation = {
    hidden: { opacity: 0, y: -20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.4,
        ease: "easeOut"
      }
    }
  };

  const menuItems = [
    { label: "Home", href: "#home" },
    { label: "About", href: "#about" },
    { label: "Projects", href: "#projects" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <motion.nav
      className="w-full py-8  bg-background/80 backdrop-blur-md "
      initial="hidden"
      whileInView="visible"
      viewport={{ amount: 0.3 }}
      variants={navAnimation}
    >
      <div className="container flex justify-between items-center m-auto px-4 md:px-0">
        <motion.div 
          className="flex justify-center items-center gap-2"
          variants={itemAnimation}
        >
          <img
            src={Logo}
            alt="Abdalbaset logo"
            className="w-[24px] md:w-[32px]"
          />
          <motion.h1 
            className="text-lg md:text-2xl font-bold "
            variants={itemAnimation}
          >
            Abdalbaset Ibrahem
          </motion.h1>
        </motion.div>

        {/* Desktop Menu */}
        <motion.ul 
          className="hidden md:flex items-center gap-10"
          variants={itemAnimation}
        >
          {menuItems.map((item, index) => (
            <motion.li 
              key={index}
              variants={itemAnimation}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <a
                href={item.href}
                className={`text-xl hover:text-primary  ${activeSection === item.href.slice(1) ? "text-primary_800 font-semibold" : "text-white/[.80]"} transition-all ease-in-out duration-300`}
              >
                {item.label}
              </a>
            </motion.li>
          ))}
        </motion.ul>

        {/* Mobile Menu Button */}
        <motion.button
          className="block md:hidden text-2xl"
          onClick={() => setIsOpen(!isOpen)}
          variants={itemAnimation}
          whileTap={{ scale: 0.95 }}
        >
          {isOpen ? <RiCloseFill /> : <RiMenu3Fill />}
        </motion.button>

        {/* Mobile Menu */}
        {isOpen && (
          <motion.div
            className="absolute top-full left-0 w-full h-screen flex flex-col items-center justify-center bg-background_950 backdrop-blur-md py-4 md:hidden"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            <ul className="flex flex-col items-center gap-12">
              {menuItems.map((item, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <a
                    href={item.href}
                    className={`text-2xl hover:text-primary transition-colors ${activeSection === item.href.slice(1) ? "text-primary_800 font-semibold" : "text-white/[.80]"}`}
                    onClick={() => setIsOpen(false)}
                  >
                    {item.label}
                  </a>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        )}
      </div>
    </motion.nav>
  );
};

export default Navbar;